// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G_4XU","top":"styles_top__2qIGJ","left":"styles_left__3kGO2","description":"styles_description__5pUrA"};